import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { SparkTextInput } from '../ui/spark';
import { FileService } from '../../services/fileUpload/uploadFile';
import ModalConfirmAssetDeletion from '../modals/ModalConfirmAssetDeletion';
import InputTextField from 'components/common/InputTextField';

class AssetBrowser extends Component {
    static defaultProps = {
        displayMode: 'list',
        contentFormatter: (asset, level) => {
            const ext = asset.filename && asset.filename.split('.').pop();
            if (RegExp('(jpg|png|gif|jpeg)', 'i').test(ext)) {
                return (
                    <img
                        src={`${FileService.assetUrl(
                            asset.chainid,
                            asset.hotelid,
                            null,
                            level,
                            asset.filename,
                            false,
                            asset.category
                        )}?cache=${_.get(asset, 'metadata.Timestamp', '')}`}
                        alt={asset.name}
                    />
                );
            } else {
                return <i className="spark-icon spark-icon-document"></i>;
            }
        },
        footerFormatter: asset => {
            return null;
        },
        selectMultiple: true,
        assets: [],
        view: false,
        edit: false,
        remove: true,
        hasAccessForDelete: false
    };
    static propTypes = {
        displayMode: PropTypes.string,
        footerFormatter: PropTypes.func,
        contentFormatter: PropTypes.func,
        onSelect: PropTypes.func,
        selectMultiple: PropTypes.bool,
        filter: PropTypes.string,
        category: PropTypes.string,
        afterSearchBar: PropTypes.element,
        hasAccessForDelete: PropTypes.bool
    };
    constructor(props) {
        super(props);
        this.state = {
            filteredAssets: [],
            displayedAssets: [],
            filter: '.*',
            searchText: '',
            confirmDeletion: false,
            fileToDelete: null,
            errors: []
        };
        this.onSearch = debounce(this.onSearch.bind(this), 300);
    }
    componentWillReceiveProps(nextProps) {
        if (
            nextProps.hotelId !== this.props.hotelId ||
            nextProps.chainId !== this.props.chainId ||
            nextProps.level !== this.props.level
        ) {
            FileService.getList(nextProps.chainId, nextProps.hotelId, nextProps.level, this.props.category);
        }
        if (nextProps.assets) {
            let regexp = new RegExp(this.props.filter, 'i');
            let filteredAssets = nextProps.assets.filter(asset => regexp.test(asset.filename));
            this.setState({
                filteredAssets,
                displayedAssets: filteredAssets.filter(
                    file => file.filename.toLowerCase().indexOf(this.state.searchText) !== -1
                )
            });
        }
    }

    refresh() {
        FileService.getList(this.props.chainId, this.props.hotelId, this.props.level, this.props.category);
    }

    componentDidMount() {
        this.serachInput = new SparkTextInput(this.serachInputRef);
        let regexp = new RegExp(this.props.filter);
        this.refresh();
        /*.then(assetlist=>{
                let filteredAssets = assetlist.filter((asset)=>regexp.test(asset.filename));
                this.setState({
                    filteredAssets,
                    displayedAssets: filteredAssets
                });
            });*/

        if (this.props.setRef) {
            this.props.setRef(this);
        }
    }
    componentWillUnmount() {
        if (this.serachInput) {
            if (typeof this.serachInput.remove === 'function') this.serachInput.remove(true);
        }
        this.serachInput = undefined;
        this.setState(prevState => {
            return {
                displayedAssets: prevState.displayedAssets
                    .filter(asset => asset.selected)
                    .map(asset => {
                        asset.selected = false;
                        return asset;
                    })
            };
        });
    }
    onSearch(text) {
        let searchText = text.toLowerCase();
        let displayedAssets = this.state.filteredAssets.filter(
            file => file.filename.toLowerCase().indexOf(searchText) !== -1
        );

        this.setState({
            displayedAssets,
            searchText
        });
    }
    onEdit(file) {}
    resetErrors() {
        this.setState((prevState, props) => ({
            errors: []
        }));
    }
    errorHandler(error) {
        if (!Array.isArray(error)) {
            error = [error];
        }
        this.setState((prevState, props) => ({
            errors: [...prevState.errors, ...error]
        }));
    }
    onSelect(file) {
        let selected = this.state.displayedAssets.filter(asset => asset.selected);
        if (!this.props.selectMultiple && selected.length >= 1 && !file.selected) return;
        file.selected = !file.selected;

        this.forceUpdate();
        if (this.props.onSelect && typeof this.props.onSelect === 'function') {
            this.props.onSelect(this.state.displayedAssets.filter(asset => asset.selected));
        }
    }
    onDelete(file) {
        this.setState({
            fileToDelete: file,
            confirmDeletion: true
        });
    }
    cancelDeletion() {
        this.setState({
            fileToDelete: null,
            confirmDeletion: false
        });
    }
    confirmDeletion() {
        const { chainId, level, hotelId, category } = this.props;
        return FileService.delete(chainId, hotelId, level, this.state.fileToDelete.filename, category).then(
            response => {
                this.setState({
                    fileToDelete: null,
                    confirmDeletion: false
                });
                return this.refresh();
            }
        );
    }

    renderGrid() {
        return this.state.displayedAssets.map(asset => (
            <div
                className={`spark-panel asset-browser--asset col-xs-3 ${
                    asset.selected ? 'asset-browser--asset__selected' : ''
                }`}
                key={_.get(asset, 'metadata.Timestamp', '')}
                onClick={() => {
                    this.onSelect(asset);
                }}
            >
                <div className="spark-panel__header" role="heading" tabIndex="0">
                    <h4>{asset.filename}</h4>
                </div>
                <div className="spark-panel__content">
                    <div className="row asset-browser--preview">
                        {this.props.contentFormatter(asset, this.props.level)}
                    </div>
                    <div className="row">
                        <div className="col-xs-10 col-md-5">{this.props.footerFormatter(asset, this.props.level)}</div>
                        <div className="col-xs-2 col-md-7">
                            <div className="spark-toolbar spark-toolbar--icon ready" role="menubar" tabIndex="0">
                                <div className="spark-toolbar__container--visible">
                                    {this.props.view && (
                                        <div
                                            className="spark-toolbar__item"
                                            label="Use element"
                                            aria-label="Use element"
                                            role="menubaritem"
                                            tabIndex="-1"
                                            onClick={() => {
                                                this.onSelect(asset);
                                            }}
                                        >
                                            <div className="spark-icon-check spark-toolbar__item-helper"></div>
                                        </div>
                                    )}
                                    {this.props.edit && (
                                        <div
                                            className={`spark-toolbar__item`}
                                            label="Edit element"
                                            aria-label="Edit element"
                                            role="menubaritem"
                                            tabIndex="-1"
                                            onClick={() => {
                                                this.onEdit(asset);
                                            }}
                                        >
                                            <div
                                                className="spark-icon-pencil spark-toolbar__item-helper"
                                                title="Edit"
                                            />
                                        </div>
                                    )}
                                    {this.props.remove && (
                                        <div
                                            className={`spark-toolbar__item ${
                                                this.props.hasAccessForDelete ? '' : 'disabled'
                                            }`}
                                            label="Delete element"
                                            aria-label="Delete element"
                                            role="menubaritem"
                                            tabIndex="-1"
                                            onClick={e => {
                                                if (this.props.hasAccessForDelete) {
                                                    this.onDelete(asset);
                                                }
                                                e.stopPropagation();
                                            }}
                                        >
                                            <div
                                                className="spark-icon-trash spark-toolbar__item-helper"
                                                title="Delete"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    renderErrors() {
        return this.state.errors.map(error => (
            <div className="spark-message spark-message--error">
                <i className="spark-message__icon spark-icon-ban spark-icon--fill"></i>
                <p className="spark-message__content">
                    {error.title && <b>{error.title}</b>} {error.message && error.message}
                </p>
            </div>
        ));
    }

    renderNoResults() {
        return (
            <div className="spark-panel col-xs-12">
                <div className="spark-panel__content">
                    <div className="spark-message spark-message--warning">
                        <i className="spark-message__icon spark-icon-alert-triangle spark-icon--fill"></i>
                        <p className="spark-message__content">
                            <b>No files matching criteria found</b>
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    renderList() {
        return this.state.displayedAssets.map(asset => (
            <div
                className={`spark-panel asset-browser--asset col-xs-12 ${
                    asset.selected ? 'asset-browser--asset__selected' : ''
                }`}
                onClick={() => {
                    this.onSelect(asset);
                }}
            >
                <div className="spark-panel__header" role="heading" tabIndex="0">
                    <h4>{asset.filename}</h4>
                </div>
                <div className="spark-panel__content">
                    <div className="row asset-browser--preview">{this.props.contentFormatter(asset)}</div>
                    <div className="row">
                        <div className="col-xs-10 col-md-5">{this.props.footerFormatter(asset)}</div>
                        <div className="col-xs-2 col-md-7">
                            <div className="spark-toolbar spark-toolbar--icon ready" role="menubar" tabIndex="0">
                                <div className="spark-toolbar__container--visible">
                                    {/*<div className="spark-toolbar__item" label="Use element" aria-label="Use element" role="menubaritem" tabIndex="-1" >
                                        <div className="spark-icon-check spark-toolbar__item-helper"></div>
                                    </div>*/}
                                    {this.props.edit && (
                                        <div
                                            className="spark-toolbar__item"
                                            label="Edit element"
                                            aria-label="Edit element"
                                            role="menubaritem"
                                            tabIndex="-1"
                                            onClick={() => {
                                                this.onEdit(asset);
                                            }}
                                        >
                                            <div className="spark-icon-pencil spark-toolbar__item-helper"></div>
                                        </div>
                                    )}
                                    {this.props.remove && (
                                        <div
                                            className={`spark-toolbar__item ${
                                                this.props.hasAccessForDelete ? '' : 'disabled'
                                            }`}
                                            label="Delete element"
                                            aria-label="Delete element"
                                            role="menubaritem"
                                            tabIndex="-1"
                                            onClick={() => {
                                                if (this.props.hasAccessForDelete) {
                                                    this.onDelete(asset);
                                                }
                                            }}
                                        >
                                            <div className="spark-icon-trash spark-toolbar__item-helper"></div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    render() {
        return (
            <div className="asset-browser">
                <div className="row asset-browser--search">
                    {this.props.children}
                    <div className={this.props.children ? 'col-xs-11' : 'col-xs-12'}>
                        <label
                            className="spark-input"
                            ref={node => {
                                this.serachInputRef = node;
                            }}
                        >
                            <InputTextField
                                onChange={event => this.onSearch(event.target.value)}
                                className="spark-input__field"
                                name="search-for-a-hotel"
                                role="textbox"
                            />
                            <span className="spark-label">Search for files</span>
                            <div className="spark-input__addon">
                                <i className="spark-icon-search spark-icon--md"></i>
                            </div>
                        </label>
                    </div>
                </div>
                {this.props.afterSearchBar}
                <div className="row">
                    {this.state.errors.length > 0 && this.renderErrors()}
                    {this.props.displayMode === 'grid' ? this.renderGrid() : this.renderList()}
                    {this.state.displayedAssets.length === 0 && this.renderNoResults()}
                </div>
                <ModalConfirmAssetDeletion
                    isOpen={this.state.confirmDeletion}
                    onClose={() => this.cancelDeletion()}
                    isComplex={false}
                >
                    <div className="spark-message spark-message--lg spark-message--error spark-margin-bottom">
                        <i className="spark-message__icon spark-icon-trash spark-icon--fill"></i>
                        <div className="spark-message__content">
                            <h4 className="spark-message__heading">Are you sure you want to delete this item?</h4>
                            <p>Remember to remove/replace all references to this file.</p>
                        </div>
                    </div>

                    <nav className="spark-btn-group spark-margin-top--lg">
                        <button
                            className="spark-btn spark-btn--md spark-btn--secondary spark-modal__dismiss spark-btn-group-secondary"
                            onClick={() => this.cancelDeletion()}
                        >
                            No
                        </button>
                        <button
                            className="spark-btn spark-btn--md spark-btn-group-primary"
                            onClick={() => this.confirmDeletion()}
                        >
                            Yes, I am sure
                        </button>
                    </nav>
                </ModalConfirmAssetDeletion>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        assets: state.app.selected.assets
    };
};

export default connect(mapStateToProps, null, null, { withRef: true })(AssetBrowser);



// WEBPACK FOOTER //
// ./src/components/widgets/AssetBrowser.js